// extracted by mini-css-extract-plugin
export default {"errorMsg":"errorMessage_errorMsg__uOWbN"};